import { NEW_CARS_ROUTES } from 'src/modules/newCarsV2/utils/constants';

const basePath = '/call-directory';

export const CallDirectoryRedirectionRoutes = {
  Home: basePath,
  Listing: `${basePath}/listing`,
  Description: `${basePath}/description`,
  Refer: `${basePath}/refer`,
  Search: `${basePath}/search`,
  TestDrive: '/services/test-drive',
  SellCar: '/services/sell-car?origin_path=/call_directory',
  CarDealer: `${NEW_CARS_ROUTES.dealerDetail}`,
  CarReviews: '/call-directory/rating',
  ClientCars: `${basePath}/client-cars`,
  MyDealer: `${NEW_CARS_ROUTES.dealerDetail}`,
  Servicing: `/car-servicing`,
  LinkDealer: `car-dealer/search`,
  FriendsActivity: `${basePath}/friends-activity`,
};

export enum WidgetType {
  ParkplusMembers = 'parkplus_members',
  SimilarCar = 'primary_car',
  TopChoice = 'top_choice',
  EvVehicles = 'ev_vehicles',
  TestDriveBooked = 'test_drive_booked',
  PremiumCar = 'premium_cars',
  UniqueCarOwned = 'unique_cars_owned',
  FreePetrolEarned = 'fuel_earning',
  ReferAndEarn = 'refer_and_earn',
  ServicingDone = 'servicing_done_on_parkplus',
  SocietyUsers = 'society_users',
  Dealers = 'parkplus_dealer',
  NearByDealers = 'similar_brand_nearest_dealer',
  PriceRange = 'price_range',
  All = 'all',
  SellCar = 'sell_car',
  Offerings = 'offerings',
  HybridVehicles = 'hybrid_vehicles',
  FriendsActivity = 'friends_activity',
}

export const SLIDER_IMAGES = [
  {
    title: `See your friends \n on Park+`,
    image:
      'https://parkplus-bkt-img.parkplus.io/production/parkplus-dashboard/public/phonebook_20240710154847096581.webp',
  },
  {
    title: `Which car \nthey drive`,
    image:
      'https://parkplus-bkt-img.parkplus.io/production/phonebook/public/permission_20250305110917139355_c568ef82-7401-4e2a-b445-80095c53f8ff.png',
  },
];

export const MODEL_IMAGE =
  'https://parkplus-bkt-img.parkplus.io/production/fuel-bill/public/Banner013_20230727191745795308.png';

export const profilePicColors = [
  `linear-gradient(180deg, #B5A5FA 0%, #745DF4 100%)`,
  `linear-gradient(180deg, #FDBA74 0%, #F36302 100%)`,
  `linear-gradient(180deg, #99D99A 0%, #05AF25 100%)`,
  `linear-gradient(180deg, #7AD9D3 0%, #2F8E88 100%)`,
  `linear-gradient(180deg, #96C6FF 0%, #0076FF 100%)`,
];

export const DEALER_IMAGE =
  'https://parkplus-bkt-img.parkplus.io/production/social-community/public/badge_20240401114537508678.jpeg';

export const BRAND_IMAGE =
  'https://parkplus-bkt-img.parkplus.io/production/social-community/public/badge_20240328134838590817.png';

export enum BrowsingMode {
  Public = 'public',
  Private = 'private',
  default = 'default',
}

export const SMILEY =
  'https://parkplus-bkt-img.parkplus.io/production/parkplus-dashboard/public/badge_20240703150127181312.webp';

export const CAR =
  'https://parkplus-bkt-img.parkplus.io/production/parkplus-dashboard/public/divider_20240806190932961672.webp';

export const TABS = [
  { label: 'All', value: WidgetType.All },
  { label: 'Friends', value: WidgetType.ParkplusMembers },
  { label: 'Unique Cars', value: WidgetType.UniqueCarOwned },
  { label: 'Premium Cars', value: WidgetType.PremiumCar },
  { label: 'Car Dealers', value: WidgetType.Dealers },
  { label: 'Test Drive', value: WidgetType.TestDriveBooked },
  { label: 'Service Centers', value: WidgetType.ServicingDone },
  { label: 'Sell Cars', value: WidgetType.SellCar },
];

export enum FilterTypes {
  price = 'price',
  brand = 'brand',
  bodyType = 'body_type',
  city = 'city',
}

export const SEARCH_INITIAL_STATE = {
  tabs: TABS,
  activeTab: TABS?.[0]?.value,
  tabsData: {},
  filter: null,
  searchText: '',
};

export const DEFAULT_NAME = 'Park+ User';

export enum NotificationType {
  addDealer = 'add_dealer',
  addRating = 'dealer_rating',
  addCarRating = 'vehicle_rating',
}

export enum FeedbackGroupState {
  addDealer = 'add_dealer',
  addDealerRating = 'dealer_rating',
  addCarRating = 'vehicle_rating',
  feedbackRequested = 'feedback_requested',
  rated = 'rated',
}

export enum RatingTabs {
  Car = 'vehicle_rating',
  Dealer = 'dealer_rating',
}

export enum RatingSteps {
  NoResult = 'NO_RESULT',
  UserInfo = 'USER_INFO',
  CarRatingZero = 0, // if no vehicle exist
  CarRatingFirst = 1, // if vehicle exist and is no rated
  CarRatingSecond = 2, // if partially rated
  CarRatingThird = 3, // completed
  AddDealer = 'DEFAULT',
  RateDealer = 'MAPPED',
  FlowComplete = 'FlowComplete',
  Moderation = 'Moderation',
  UserReviews = 'RATED',
  UploadImage = 'UPLOAD_IMAGE',
  ImageRejected = 'IMAGE_REJECTED',
  SuccessScreen = 'success_screen',
  ImageSuccessScreen = 'image_success_screen',
  ReviewRejected = 'REJECTED',
}

export const BUTTON_TEXT = {
  [RatingSteps.NoResult]: 'Try again',
  [RatingSteps.UserInfo]: 'Help now',
  [RatingSteps.CarRatingZero]: '',
  [RatingSteps.CarRatingFirst]: '',
  [RatingSteps.CarRatingSecond]: '',
  [RatingSteps.CarRatingThird]: 'Next',
  [RatingSteps.AddDealer]: 'Find car dealer',
  [RatingSteps.RateDealer]: 'Rate car dealer',
  [RatingSteps.FlowComplete]: 'Next',
  [RatingSteps.UserReviews]: 'Done',
  [RatingSteps.Moderation]: 'Done',
  [RatingSteps.UploadImage]: 'Upload Image',
  [RatingSteps.ImageRejected]: 'Re Upload Image',
};

export const TITLE = {
  [RatingSteps.NoResult]: '',
  [RatingSteps.UserInfo]: '',
  [RatingSteps.CarRatingZero]: 'Rate your car',
  [RatingSteps.CarRatingFirst]: 'Rate your car',
  [RatingSteps.CarRatingSecond]: 'Rate your car',
  [RatingSteps.CarRatingThird]: 'Rate your car',
  [RatingSteps.AddDealer]: 'Add your car dealer',
  [RatingSteps.RateDealer]: 'Rate your car dealer',
  [RatingSteps.FlowComplete]: 'Your review',
  [RatingSteps.UserReviews]: 'Your review',
  [RatingSteps.Moderation]: 'Your review',
  [RatingSteps.UploadImage]: 'Upload your car image',
};

export const showCardDetailCard = [
  RatingSteps.CarRatingThird,
  RatingSteps.AddDealer,
  RatingSteps.RateDealer,
];

export const hideTimeline = [
  RatingSteps.UserInfo,
  RatingSteps.UserReviews,
  RatingSteps.NoResult,
  RatingSteps.Moderation,
  RatingSteps.ImageRejected,
];

export enum RewardType {
  Car = 'Car',
  AddDealer = 'Add',
  RateDealer = 'RateDealer',
  ImageUploaded = 'ImageUploaded',
}

export const DESCRIPTION = {
  [RewardType.Car]:
    'Great stuff! You are helping your friends make an informed decision, continue to add your dealer and earn more Park+ Petrol',
  [RewardType.AddDealer]:
    'Great stuff! You are helping your friends make an informed decision, continue to rate your dealer and earn more Park+ Petrol',
  [RewardType.RateDealer]:
    'Congratulations! You are a Park+ car wizard and your reviews will guide your friends on their car buying journey',
  [RewardType.ImageUploaded]:
    'Fantastic! Your image has been successfully uploaded. Every picture counts in helping others choose wisely!',
};

import AmazingJson from 'public/json/car-reviews/amazing.json';
import AverageJson from 'public/json/car-reviews/average.json';
import BadJson from 'public/json/car-reviews/bad.json';
import GoodJson from 'public/json/car-reviews/good.json';
import PoorJson from 'public/json/car-reviews/poor.json';

export const RATING_DATA = {
  1: {
    image: PoorJson,
    title: 'Poor',
    iconPrimaryColor: 'negative',
    iconSecondaryColor: 'negative_hover',
  },
  2: {
    image: BadJson,
    title: 'Bad',
    iconPrimaryColor: 'negative',
    iconSecondaryColor: 'negative_hover',
  },
  3: {
    image: AverageJson,
    title: 'Average',
    iconPrimaryColor: 'alert',
    iconSecondaryColor: 'alert_dark',
  },
  4: {
    image: GoodJson,
    title: 'Good',
    iconPrimaryColor: 'positive',
    iconSecondaryColor: 'positive_hover',
  },
  5: {
    image: AmazingJson,
    title: 'Amazing',
    iconPrimaryColor: 'positive',
    iconSecondaryColor: 'positive_hover',
  },
};

export const RATING_TYPES = [
  {
    type: 'comfort_rating',
    title: 'Comfort & Space*',
  },
  {
    type: 'performance_rating',
    title: 'Performance*',
  },
  {
    type: 'value_for_money',
    title: 'Value for money*',
  },
];

export const DEFAULT_DISTANCE = 10000;

export const MileageData = {
  electric: {
    min: 100,
    max: 1000,
    default: 250,
    title: 'What is the range of your car',
    type: 'driving_range',
    suffix: 'Km',
    steps: 0,
  },
  other: {
    min: 2,
    max: 40,
    default: 12,
    title: 'What is the current mileage of your car?',
    type: 'mileage',
    suffix: 'Km/Ltr',
    steps: 0,
  },
};

export const MaintenanceCost = {
  type: 'maintenance_cost',
  list: [
    {
      title: 'Upto ₹10,000',
      value: 10000,
    },
    {
      title: '₹10,000 - ₹20,000',
      value: 20000,
    },
    {
      title: 'Above ₹20,000',
      value: 30000,
    },
  ],
};

export const PurchaseReason = {
  type: 'purchase_reason',
  list: [
    {
      title: 'Convenience',
      value: 'Convenience',
    },
    {
      title: 'Comfort',
      value: 'Comfort',
    },
    {
      title: 'Safety',
      value: 'Safety',
    },
    {
      title: 'Family',
      value: 'Family',
    },
    {
      title: 'Travel',
      value: 'Travel',
    },
  ],
};

export const DealerList = {
  type: 'user_reviews',
  list: [
    {
      title: 'OEM authorised service centres',
      value: 'OEM authorised service centres',
    },
    {
      title: 'Third party service centres',
      value: 'Third party service centres',
    },
  ],
};

export const INPUT_ERR = 'A review should be at least 60 characters';
